import * as React from "react";
const SvgIcAdd = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.5 3H13.5V10.5H21V13.5H13.5V21H10.5V13.5H3V10.5H10.5V3Z" fill="currentColor" /></svg>;
export default SvgIcAdd;